const KEY = 'ei-cart-freight-v1';

export const readFreightMemory = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

export const saveFreightMemory = (value) => {
  localStorage.setItem(KEY, JSON.stringify(value));
};

// The remembered estimate is only valid for the exact cart it was priced on.
export const cartSignature = (lines) =>
  (lines || []).map((line) => `${line.kind}:${line.id}:${line.quantity}`).sort().join('|');

export const clearFreightMemory = () => localStorage.removeItem(KEY);
